var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4158 4.30462V2.14781C18.4158 1.96087 18.201 1.85764 18.0559 1.97203L5.47775 11.7963C5.37088 11.8794 5.28441 11.9858 5.22493 12.1074C5.16544 12.229 5.13452 12.3626 5.13452 12.498C5.13452 12.6334 5.16544 12.767 5.22493 12.8886C5.28441 13.0102 5.37088 13.1166 5.47775 13.1997L18.0559 23.0239C18.2038 23.1383 18.4158 23.0351 18.4158 22.8482V20.6913C18.4158 20.5546 18.3516 20.4235 18.2456 20.3398L8.20097 12.4994L18.2456 4.65618C18.3516 4.57248 18.4158 4.44134 18.4158 4.30462Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.646916d4.svg";
export { ForwardRef as ReactComponent };